<template>
    <div class="list-section">
        <!-- 存在其他地方使用这个样式，解决后再删除 -->
        <div class="list-section-content" :class="contentClass">
            <slot></slot>
        </div>
    </div>
</template>
<script>
/**
 * section，仅添加了padding-top: 10
 */
export default {
    name: 'ListSection',
    props: {
        /**
         * 内容样式类
         */
        contentClass: {
            type: [ Array, Object ],
        },
    },
};
</script>
<style lang="less">
    @import "../../lib/style/mixins.less";
    @import "../../lib/style/util.less";
    .list-section {
        padding-top: @list-section-gap;
    }
</style>
